export default __webpack_public_path__ + "static/media/mus-willhe.6bbccc1c.mp4";